// config.js
export default {
    version: "2.7.2",
    user: 0,
    session_user: "Admin",
    session_password: "2025UVR018@",
    production: 1,
};
/* v!9zhcQ5GTrAPu3
ssh -p 65002 u354034342@82.180.168.179
ssh -p 65002 u354034342@82.180.168.179
 */
/* v!9zhcQ5GTrAPu3 */
/*  
*/

/* 
tecnico = 1,
user: 1,
session_user: "UVR-tec1@uviereport.com",
session_password: "UVR2025",

admin = 0
user: 0,
session_user: "Admin",
session_password: "2025UVR018@"
 */